var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow-y":"scroll","height":"100vh"}},[_c('pre',{staticClass:"pre"},[_vm._v(_vm._s(_vm.txtPre)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }